module.exports = __webpack_public_path__ + "static/media/120-1.43fcc8cd.svg";